<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="fmh1"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix">CONTENTS</span></p>
<p class="toc0" id="rcover"><a href="#/text/9780802156969_Cover#cover">Cover</a></p>
<p class="toc0" id="rtitle"><a href="#/text/9780802156969_TitlePage#title">Title Page</a></p>
<p class="toc0" id="rscopy"><a href="#/text/9780802156969_Copyright#copy">Copyright</a></p>
<p class="toc0" id="rded"><a href="#/text/9780802156969_Dedcation#ded">Dedcation</a></p>
<p class="toc0" id="repi"><a href="#/text/9780802156969_Front2#epi">Epigraph</a></p>
<p class="toc" id="rpart1"><a href="#/text/9780802156969_Part_1#part1">I<br/>The Shipment</a></p>
<p class="toc1" id="rch1"><a href="#/text/9780802156969_Chapter_1#ch1">Eddie and Alberto</a></p>
<p class="toc0" id="rch2"><a href="#/text/9780802156969_Chapter_2#ch2">The Crews</a></p>
<p class="toc0" id="rch3"><a href="#/text/9780802156969_Chapter_3#ch3">Rodrigo and Mateo and Charlie</a></p>
<p class="toc0" id="rch4"><a href="#/text/9780802156969_Chapter_4#ch4">Rudy</a></p>
<p class="toc0" id="rch5"><span href="#/text/9780802156969_Chapter_5#ch5" title="Link target outside of Sample">Jessie and Charlie</span></p>
<p class="toc" id="rpart2"><span href="#/text/9780802156969_Part_2#part2" title="Link target outside of Sample">II<br/>The Girl</span></p>
<p class="toc1" id="rch6"><span href="#/text/9780802156969_Chapter_6#ch6" title="Link target outside of Sample">Catalina</span></p>
<p class="toc0" id="rch7"><span href="#/text/9780802156969_Chapter_7#ch7" title="Link target outside of Sample">Catalina and Jessie and Charlie</span></p>
<p class="toc0" id="rch8"><span href="#/text/9780802156969_Chapter_8#ch8" title="Link target outside of Sample">Rudy</span></p>
<p class="toc" id="rpart3"><span href="#/text/9780802156969_Part_3#part3" title="Link target outside of Sample">III<br/>The Crossings</span></p>
<p class="toc1" id="rch9"><span href="#/text/9780802156969_Chapter_9#ch9" title="Link target outside of Sample">Rudy</span></p>
<p class="toc0" id="rch10"><span href="#/text/9780802156969_Chapter_10#ch10" title="Link target outside of Sample">Rayo Luna</span></p>
<p class="toc0" id="rch11"><span href="#/text/9780802156969_Chapter_11#ch11" title="Link target outside of Sample">Rudy</span></p>
<p class="toc0" id="rch12"><span href="#/text/9780802156969_Chapter_12#ch12" title="Link target outside of Sample">El Chubasco</span></p>
<p class="toc0" id="rch13"><span href="#/text/9780802156969_Chapter_13#ch13" title="Link target outside of Sample">Rudy</span></p>
<p class="toc0" id="rch14"><span href="#/text/9780802156969_Chapter_14#ch14" title="Link target outside of Sample">El Chubasco</span></p>
<p class="toc0" id="rch15"><span href="#/text/9780802156969_Chapter_15#ch15" title="Link target outside of Sample">Rudy</span></p>
<p class="toc0" id="rch16"><span href="#/text/9780802156969_Chapter_16#ch16" title="Link target outside of Sample">El Chubasco</span></p>
<p class="toc0" id="rch17"><span href="#/text/9780802156969_Chapter_17#ch17" title="Link target outside of Sample">Rudy</span></p>
<p class="toc0" id="rch18"><span href="#/text/9780802156969_Chapter_18#ch18" title="Link target outside of Sample">El Chubasco</span></p>
<p class="toc0" id="rch19"><span href="#/text/9780802156969_Chapter_19#ch19" title="Link target outside of Sample">Rudy</span><span class="right_1" epub:type="pagebreak" id="page_x" title="x"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802156969_Contents.vue?c1f81e64